import {
  ASK_NOTIFICATION_PERMISSION,
  CLEAR_NOTIFICATION_PERMISSION,
  NOTIFICATION_POPUP_SHOWN
} from "../actions";

export function askNotificationPermission() {
  return {
    type: ASK_NOTIFICATION_PERMISSION
  };
}

export function clearNotificationPermission() {
  return {
    type: CLEAR_NOTIFICATION_PERMISSION
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/firebaseDetails.js